import { Component } from '@angular/core';

@Component({
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss']
})
export class PlanComponent {}
